var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("h1", [_vm._v("Anuncios Generales")]),
    _vm._v(" "),
    _c("div", { staticClass: "coloumns" }, [
      _c(
        "div",
        { staticClass: "coloumn" },
        [
          _vm._l(_vm.statuses, function(status, id) {
            return _c("div", { key: id, staticClass: "message" }, [
              _c("div", { staticClass: "message-header" }, [
                _c("p", { staticStyle: { "text-transform": "capitalize" } }, [
                  _vm._v(_vm._s(status.user.name) + " dijo...")
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    attrs: { title: _vm._f("fechaMoment")(status.created_at) }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm._f("capitalize")(_vm._f("ago")(status.created_at))
                        ) +
                        "\n                        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "message-body" }, [
                _c("p", [
                  _vm._v(
                    "\n                            " +
                      _vm._s(status.body) +
                      "\n                        "
                  )
                ])
              ])
            ])
          }),
          _vm._v(" "),
          !_vm.esAnonimo && !_vm.esCliente
            ? _c("agregar-nuevo-estado", {
                on: { completed: _vm.agregarNuevoEstado }
              })
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }